var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34122 0.171522C5.94916 0.441528 5.8856 0.934015 6.19924 1.27152L10.5934 6L6.19924 10.7285C5.8856 11.066 5.94916 11.5585 6.34122 11.8285C6.73327 12.0985 7.30535 12.0438 7.619 11.7063L12.4675 6.48889C12.7331 6.20307 12.7331 5.79693 12.4675 5.51111L7.619 0.293744C7.30535 -0.0437635 6.73327 -0.0984842 6.34122 0.171522Z",
    fill: "#202A45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.341218 0.171522C-0.0508362 0.441528 -0.114401 0.934015 0.199243 1.27152L4.59338 6L0.199243 10.7285C-0.1144 11.066 -0.0508357 11.5585 0.341219 11.8285C0.733273 12.0985 1.30535 12.0438 1.619 11.7063L6.46746 6.48889C6.73307 6.20307 6.73307 5.79693 6.46746 5.51111L1.619 0.293744C1.30535 -0.0437635 0.733272 -0.0984842 0.341218 0.171522Z",
    fill: "#202A45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrows);
export default __webpack_public_path__ + "static/media/rightArrows.419fe6dbd0c33632eb23a87425aa5e2c.svg";
export { ForwardRef as ReactComponent };